import { useContext } from 'react';
import { RulesListContext, TagsAndRulesWithTags } from './RulesListContext';

export default function useRulesList(): TagsAndRulesWithTags {
  const contextValue = useContext(RulesListContext);
  if (!contextValue) {
    throw new Error('cannot find RulesListContext in current subtree');
  }
  return contextValue;
}
